import React from 'react';
import {
  type FragmentType,
  getFragment,
  gql,
  TrendingPlaylistPostFragmentDoc,
} from '@graphql/reactQuery';
import { usePostContent } from '@hooks/usePostContent';
import { PlaylistWidget } from './PlaylistWidget';
import { TrendingPostItem } from './TrendingPostItem';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment TrendingPlaylistPost on PlaylistPost {
    id
    creator {
      id
      ...UserActivityDetail
    }
    optionalShelf {
      id
      ...PlaylistPreview
    }
    content
    lexicalContent
    createdAt
    webappUri
    ...FeedPostActionsInfo
  }
`);

export function PlaylistPost({ post }: { post: FragmentType<TrendingPlaylistPostFragmentDoc> }) {
  const playlistPost = getFragment(TrendingPlaylistPostFragmentDoc, post);
  const {
    id: postId,
    creator,
    optionalShelf,
    content,
    lexicalContent,
    createdAt,
    webappUri,
  } = playlistPost;

  const { content: postContent } = usePostContent({ lexicalContent, content });

  return (
    <TrendingPostItem
      postFrag={playlistPost}
      creatorFrag={creator}
      content={postContent}
      postId={postId}
      createdAt={createdAt}
      webappUri={webappUri}
    >
      {optionalShelf && <PlaylistWidget playlistFrag={optionalShelf} />}
    </TrendingPostItem>
  );
}
